import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { InputAdornment } from '@mui/material';
import { TextFieldForms } from 'app/shared/layout/register/DefaultFormsComponents';
import React, { useEffect, useRef, useState } from 'react';

const isGooglePlacesLoaded = () => typeof window !== 'undefined' && Boolean((window as any).google?.maps?.places);

export const AutoCompleteSearch = ({ setLatitude, setLongitude, setIsAutoComplete, disabled = false }) => {
  const autoCompleteRef = useRef<any>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [mapsLoaded, setMapsLoaded] = useState(isGooglePlacesLoaded);

  useEffect(() => {
    if (mapsLoaded) {
      return;
    }

    const intervalId = window.setInterval(() => {
      if (isGooglePlacesLoaded()) {
        setMapsLoaded(true);
        window.clearInterval(intervalId);
      }
    }, 100);

    return () => window.clearInterval(intervalId);
  }, [mapsLoaded]);

  useEffect(() => {
    const googleMaps = (window as any).google?.maps;
    if (!mapsLoaded || !googleMaps?.places || !inputRef.current) {
      return;
    }

    autoCompleteRef.current = new googleMaps.places.Autocomplete(inputRef.current, {
      componentRestrictions: { country: 'br' },
      fields: ['geometry'],
    });

    const listener = autoCompleteRef.current.addListener('place_changed', function () {
      const place = autoCompleteRef.current.getPlace();

      if (!disabled && place.geometry) {
        setIsAutoComplete(true);
        setLatitude(place.geometry.location.lat());
        setLongitude(place.geometry.location.lng());
      }
    });

    return () => listener.remove();
  }, [mapsLoaded, setIsAutoComplete, setLatitude, setLongitude]);

  return (
    <TextFieldForms
      inputRef={inputRef}
      placeholder="Pesquise um endereço"
      size="small"
      disabled={disabled}
      fullWidth
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <SearchRoundedIcon color="secondary" fontSize="small" />
          </InputAdornment>
        ),
      }}
      sx={{
        height: 43,
        '& .MuiOutlinedInput-root': {
          borderRadius: '8px',
          height: '43px',
          fontSize: '0.875rem',
        },
        '& .MuiInputBase-input': {
          py: '10px',
        },
      }}
    />
  );
};
